import { stringToDate, TaskPriorities, } from "./task.type";
import { getRequestFromTaskTemplate, getTaskTemplateFromDto, } from "./taskTemplate.type";
export const getBlankActionPlanTemplate = () => ({
    title: "",
    enabled: true,
    priority: TaskPriorities.medium,
    templates: [],
});
export const getActionPlanTemplateFromDto = (dto) => (Object.assign(Object.assign({}, dto), { createdDate: stringToDate(dto.createdDate), modifiedDate: stringToDate(dto.modifiedDate), templates: dto.templates.map(getTaskTemplateFromDto) }));
export const getRequestFromActionPlanTemplate = (plan) => {
    const request = {
        title: plan.title,
        templates: plan.templates.map(getRequestFromTaskTemplate),
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        templateTitle: plan.templateTitle,
    };
    if (plan.id) {
        request.id = plan.id;
    }
    if (plan.description) {
        request.description = plan.description;
    }
    if (plan.templateDescription) {
        request.templateDescription = plan.templateDescription;
    }
    if (plan.associatedPeople) {
        request.associatedPeople = plan.associatedPeople.map((person) => person.personId);
    }
    if (plan.resources) {
        request.resources = plan.resources.map((resource) => resource.id);
    }
    if (plan.status) {
        request.statusId = plan.status.id;
    }
    if (plan.priority) {
        request.priorityId = plan.priority.id;
    }
    if (plan.enabled !== null && plan.enabled !== undefined) {
        request.enabled = plan.enabled;
    }
    return request;
};
